import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { divisorColor } from 'src/constants/stylesheet';
import ExhibitionsPreview from './ExhibitionsPreview';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      overflowX: 'hidden',
    },
    section: {
      position: 'relative',

      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        width: '100vw',
        height: 1,
        transform: 'translateX(-50%)',
        backgroundColor: divisorColor
      },
      [mediaQueries.Mobile]: {
        paddingLeft: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
        paddingRight: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
        paddingRight: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
        paddingRight: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
        paddingRight: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
      },
      [mediaQueries.BigDesktop]: {
        paddingLeft: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
        paddingRight: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
      },
    },
    content: {
      display: 'flex',
      flexWrap: 'wrap',
    },

    // grid 
    gridTitle: {
      ...stylesheet.SubTitle,
    },

    gridTitleMargin: {
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
        paddingTop: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,

        fontSize: '1.25rem'
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
        paddingTop: spacing.Gutter.Tablet * 0.75,
        paddingBottom: spacing.Gutter.Tablet * 0.75,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
        paddingTop: spacing.Gutter.Laptop * 0.75,
        paddingBottom: spacing.Gutter.Laptop * 0.75,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
        paddingTop: spacing.Gutter.Desktop * 0.75,
        paddingBottom: spacing.Gutter.Desktop * 0.75,
      },
      [mediaQueries.BigDesktop]: {
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
        paddingTop: spacing.Gutter.BigDesktop * 0.75,
        paddingBottom: spacing.Gutter.BigDesktop * 0.75,
      },
    },
  }));

export type FairsProps = FairsDto;

type Props = FairsProps;

const Fairs: FC<Props> = (props) => {
  const cls = useStyles();

  const { FairItems, Title } = props;

  return (
    <div className={cls.root}>
      <section className={cls.section}>
        <h5 className={classNames(cls.gridTitle, cls.gridTitleMargin)}>{Title}</h5>
        <div className={cls.content}>
          {
            FairItems && FairItems.map((item, i) =>
              <ExhibitionsPreview
                key={item.UID}
                delayIndex={i}
                {...item}
              />)
          }
        </div>
      </section>
    </div>
  );
};

export default Fairs;



// WEBPACK FOOTER //
// ./src/Components/Fairs.tsx